import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  class: "content",
  style: {"padding":"0","margin":"0"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "College Partnerships", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " If you represent a college or university and would like to offer NSSI programs as an option for your students, fill out the form below. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "fieldleft" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, [
  /*#__PURE__*/_createTextVNode("Full Name "),
  /*#__PURE__*/_createElementVNode("red", null, "*")
], -1)
const _hoisted_9 = { class: "fieldright" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, [
  /*#__PURE__*/_createTextVNode("Title "),
  /*#__PURE__*/_createElementVNode("red", null, "*")
], -1)
const _hoisted_11 = { class: "fieldleft" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("red", null, "*")
], -1)
const _hoisted_13 = { class: "fieldright" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, [
  /*#__PURE__*/_createTextVNode("Phone "),
  /*#__PURE__*/_createElementVNode("red", null, "*")
], -1)
const _hoisted_15 = { class: "fieldleft" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, [
  /*#__PURE__*/_createTextVNode("College / University "),
  /*#__PURE__*/_createElementVNode("red", null, "*")
], -1)
const _hoisted_17 = { class: "fieldright" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, [
  /*#__PURE__*/_createTextVNode("City "),
  /*#__PURE__*/_createElementVNode("red", null, "*")
], -1)
const _hoisted_19 = { class: "fieldleft" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, [
  /*#__PURE__*/_createTextVNode("State "),
  /*#__PURE__*/_createElementVNode("red", null, "*")
], -1)
const _hoisted_21 = { class: "fieldright" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, [
  /*#__PURE__*/_createTextVNode("Approx. # of Students "),
  /*#__PURE__*/_createElementVNode("red", null, "*")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_24 = { class: "field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, [
  /*#__PURE__*/_createTextVNode("I am looking for... "),
  /*#__PURE__*/_createElementVNode("red", null, "*")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "college-ineed1" }, "General Information", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "college-ineed2" }, "Print Materials", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "college-ineed3" }, "Digital Materials", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { class: "field" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, [
  /*#__PURE__*/_createTextVNode("Comments "),
  /*#__PURE__*/_createElementVNode("red", null, "*")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = { style: {"text-align":"center"} }
const _hoisted_41 = ["disabled"]

import { Partnership } from "@/models/Partnership";
import Loader from "@/components/MainLoader.vue";
import { EmailService } from "@/api/EmailService";
import StatusComponent from "@/components/StatusComponent.vue";
import { Ref, ref, ComputedRef, computed } from "vue";
import { useReCaptcha } from "vue-recaptcha-v3";
import { useStatusStore } from "@/stores/root/status";
import { stat } from "@/utils/Utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnershipsModal',
  setup(__props) {

const partnership = ref(new Partnership());
const loading = ref(false);
const captchaResoult: Ref<boolean> = ref(false);
const showInfo = ref(false);
const showErr = ref(false);
const statusStore = useStatusStore();
const gReCaptcha = useReCaptcha();
const recaptcha = async () => {
  // (optional) Wait until recaptcha has been loaded.
  await gReCaptcha?.recaptchaLoaded();

  // Execute reCAPTCHA with action "login".
  const token = await gReCaptcha?.executeRecaptcha("submit");
  if (token) {
    captchaResoult.value = true;
  } else {
    captchaResoult.value = false;
  }
};

/**
 * Validates required fields.
 */
const validate: ComputedRef<boolean> = computed(() => {
  return (
    partnership.value.fullName.length > 0 &&
    partnership.value.title.length > 0 &&
    partnership.value.comments.length > 0 &&
    partnership.value.email.length > 0 &&
    partnership.value.phone.length > 0 &&
    partnership.value.college.length > 0 &&
    partnership.value.city.length > 0 &&
    partnership.value.state.length > 0 &&
    partnership.value.nrOfStudents > 0 &&
    (partnership.value.infoDigital ||
      partnership.value.infoGeneral ||
      partnership.value.infoPrint)
  );
});

/**
 * Checks captcha and send email.
 */
const send = async (): Promise<void> => {
  await recaptcha();
  if (stat(statusStore)) {
    stat(statusStore).clear();
  }

  loading.value = true;
  const sendMail = await EmailService.sendCollegePartnershipInfo(
    partnership.value
  );
  loading.value = false;
  sendMail.error ? (showErr.value = true) : (showInfo.value = true);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showInfo.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Message Sent! If necessary, one of our representatives will be in contact with you soon. You may close this window. "))
      : _createCommentVNode("", true),
    (showErr.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Something went wrong, please try again later."))
      : _createCommentVNode("", true),
    (!showInfo.value && !showErr.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 2,
          onSubmit: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (send()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
            _hoisted_4,
            _createVNode(StatusComponent),
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((partnership.value.fullName) = $event)),
                type: "text"
              }, null, 512), [
                [_vModelText, partnership.value.fullName]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((partnership.value.title) = $event)),
                type: "text"
              }, null, 512), [
                [_vModelText, partnership.value.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((partnership.value.email) = $event)),
                type: "text"
              }, null, 512), [
                [_vModelText, partnership.value.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((partnership.value.phone) = $event)),
                type: "text"
              }, null, 512), [
                [_vModelText, partnership.value.phone]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((partnership.value.college) = $event)),
                type: "text"
              }, null, 512), [
                [_vModelText, partnership.value.college]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((partnership.value.city) = $event)),
                type: "text"
              }, null, 512), [
                [_vModelText, partnership.value.city]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((partnership.value.state) = $event)),
                type: "text"
              }, null, 512), [
                [_vModelText, partnership.value.state]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((partnership.value.nrOfStudents) = $event)),
                type: "number",
                min: "0"
              }, null, 512), [
                [_vModelText, partnership.value.nrOfStudents]
              ])
            ]),
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("input", {
                id: "college-ineed1",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((partnership.value.infoGeneral) = $event)),
                type: "checkbox",
                class: "styledchecked extraspacecheck",
                name: "college-ineed",
                "true-value": true
              }, null, 512), [
                [_vModelCheckbox, partnership.value.infoGeneral]
              ]),
              _hoisted_26,
              _hoisted_27,
              _withDirectives(_createElementVNode("input", {
                id: "college-ineed2",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((partnership.value.infoPrint) = $event)),
                type: "checkbox",
                class: "styledchecked extraspacecheck",
                name: "college-ineed",
                "true-value": true
              }, null, 512), [
                [_vModelCheckbox, partnership.value.infoPrint]
              ]),
              _hoisted_28,
              _hoisted_29,
              _withDirectives(_createElementVNode("input", {
                id: "college-ineed3",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((partnership.value.infoDigital) = $event)),
                type: "checkbox",
                class: "styledchecked extraspacecheck",
                name: "college-ineed",
                "true-value": true
              }, null, 512), [
                [_vModelCheckbox, partnership.value.infoDigital]
              ]),
              _hoisted_30,
              _hoisted_31
            ]),
            _hoisted_32,
            _hoisted_33,
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((partnership.value.comments) = $event))
              }, null, 512), [
                [_vModelText, partnership.value.comments]
              ])
            ]),
            _hoisted_37,
            _hoisted_38,
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("button", {
                disabled: !validate.value,
                type: "submit"
              }, "Send", 8, _hoisted_41)
            ])
          ])
        ], 32))
      : _createCommentVNode("", true)
  ], 64))
}
}

})